export default __webpack_public_path__ + "static/media/logo_long2.5b22171d.png";